import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: '[app-drivers-report]',
    templateUrl: './drivers-report.component.html',
    styleUrls: ['./drivers-report.component.css'],
    standalone: false
})
export class DriversReportComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "DriversReport" }));
  }
}
